import { Object3D, PerspectiveCamera, Vector2 } from 'three'
import App from './App'

export class Camera {
	private readonly app: App
	private readonly camera: PerspectiveCamera
	private readonly dolly: Object3D = new Object3D()
	private readonly outerDolly: Object3D = new Object3D()
	private readonly pointer: Vector2 = new Vector2()

	constructor(app: App) {
		this.app = app
		this.camera = new PerspectiveCamera(35)
		this.camera.near = 0.001
		this.camera.far = 100
		this.camera.lookAt(this.app.scene.position)
		this.dolly.add(this.camera)
		this.outerDolly.add(this.dolly)
		this.app.scene.add(this.outerDolly)
	}

	getCamera() {
		return this.camera
	}

	resize() {
		const { width, height } = this.app.sizes
		this.camera.aspect = width / height
		this.camera.updateProjectionMatrix()

		this.camera.position.z = this.app.sizes.isDesktop ? 3.5 : 5
	}

	update(): void {
		const distance = this.pointer.distanceTo(this.app.pointerControls.pointer)
		if (distance > 0.01) {
			this.pointer.lerp(this.app.pointerControls.pointer, 0.1)
			this.dolly.rotation.set(this.pointer.y * 0.2, this.pointer.x * -0.2, 0)
			this.app.requestRender()
		}
	}
}
